import { Alert, Flex } from "@mantine/core";
import { useEffect, useState } from "react";

import type { ChatVariant } from "../ChatQueue/variants";

import classes from "./ChatAlertBanner.module.css";
import { chatAlertBannerConfig } from "./chatAlertBannerConfig";

export const ChatAlertBanner = ({ variant }: { variant: ChatVariant }) => {
    const [visible, setVisible] = useState(true);
    const config = chatAlertBannerConfig[variant];

    useEffect(() => {
        setVisible(true);
    }, [variant]);

    if (!config || !visible) return null;

    return (
        <Flex m="xs" wrap="wrap">
            <Alert
                id={`chat-alert-banner-${variant}`}
                icon={config.icon}
                color={config.color}
                title={config.title}
                withCloseButton={config.showClose}
                onClose={() => setVisible(false)}
                classNames={{
                    title: classes.title,
                }}
                styles={{
                    closeButton: {
                        color: config.closeButtonColor,
                    },
                }}
                w="100%"
            >
                {config.description}
            </Alert>
        </Flex>
    );
};
